<template>
  <div class="box boxbgcolor">
    <el-row>
      <el-col :span="24">
        <div class="top">
          <div class="weather float"></div>
          <div class="titleBg">
            <p class="titleChina_">HR 能耗数据实时展示</p>
            <p class="titleEnglish_">HR energy consumption data real-time display</p>
          </div>
          <div class="logo float">
            <i></i>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="8">
        <Nyfk :carddata="carddata" :carddataTitle="'今日用能统计'"></Nyfk>
      </el-col>
      <el-col :span="8">
        <no-production-ganuge :threedata="threedata" v-if="chartMaxMinData" :chartMaxMinData="chartMaxMinData"></no-production-ganuge>
      </el-col>
      <el-col :span="8">
        <Bar :barDate="barDate" :title="'年/月/周/日 用电能耗(kW▪h)'"></Bar>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <Zline :yd="ys" :ydTitle="'用水分时能耗(m³)'"></Zline>
      </el-col>
      <el-col :span="12">
        <Zline :yd="yd" :ydTitle="'用电分时能耗(kW▪h)'"></Zline>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import noProductionGanuge from "./pages/noProductionGanuge";
import Bar from "./pages/Bar";
import Zline from "./pages/Zline";
import Nyfk from "./pages/Nyfk";
import { isNull, isUndefined } from "util";
import {
  getDate,
  getTime,
  getCustomUrlParam,
  formatDate,
  formatTime,
  getX,
  getxData,
  addWeek,
  findDataByParam
} from "@/utils/index";
import * as utils from "@/utils/index.js";
export default {
  name: "HR",
  components: {
    noProductionGanuge,
    Bar,
    Zline,
    Nyfk
  },
  /* 組件离开 */
  beforeRouteLeave (to, from, next) {
    let vm = this
    if (vm.timer) {
      clearInterval(vm.timer);
    }
    next();
  },
  data () {
    return {
      fullscreen: false,
      StandardCoalCoefficientOfElectricity: "", //电折标系数
      StandardCoalCoefficientOfWater: "", //水折标系数
      companyID: 0, //公司id
      url: "/energyKanban/HR",
      params: "",
      tjParams: [], //电水产量参数数组
      yearEle: [], //年用电量柱状图数据
      monthEle: [], //月电量柱状图数据
      weekEle: [], //周电量柱状图数据
      dayEle: [], //日电量柱状图数据
      todayHourElc: [], //今天时电量柱状图数据
      todayHourWat: [], //今天时水量柱状图数据
      lastHourElc: [], //昨天时电量柱状图数据
      lastHourWat: [], //昨天时水量柱状图数据
      tyd: "", //电的统计量,
      tys: "", //水统计
      segments: [], //日周的时间段
      eleNode: "", //电计量点
      eleCode: "", //电测量编码
      eleNum: "",
      waterNode: "", //水计量点
      waterCode: "",
      waterNum: "",
      pageFlag: true,
      threedata: [], //罗盘数据
      barDate: {}, //柱状图数据
      carddata: [], //卡片数据
      yd: [], //用电数据
      ys: [], //用水数据
      setGuan: {}, //设置罗盘大小
      data: {
        data: {
          ee_tempdata: [
            {
              data: [],
              name: "当日用电单耗量"
            },
            {
              data: [],
              name: "昨日用电单耗量"
            }
          ],
          ww_tempdata: [
            {
              data: [],
              name: "当日用水单耗量"
            },
            {
              data: [],
              name: "昨日用水单耗量"
            }
          ],
          yerDate: {
            xdata: [
              "2018",
              "2019",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "W42",
              "W43",
              "W44",
              "W45",
              "W46",
              "11.08",
              "11.09",
              "11.10",
              "11.11",
              "11.12",
              "11.13",
              "11.14"
            ],
            ydata: [[], [], [], []]
          }
        }
      },
      chartMaxMinData: null,
      timer: null
    };
  },
  mounted () { },
  created () {
    this.getParams();
  },
  beforeDestroy () {
    let vm = this;
    if (vm.timer) {
      window.clearInterval(vm.timer);
    }
  },
  methods: {
    async getParams () {
      let vm = this;
      //自定义页面获取计量点ID
      let res = await vm.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(0, vm.url, vm.params)
      if (res.success) {
        let measures = findDataByParam(
          "measures",
          true,
          res.data
        );
        for (let i = 0; i < measures.length; i++) {
          let item = measures[i];
          if (item.displayName == '电') {
            vm.eleNode = item.measuredId //电计量点
            vm.eleCode = item.pointCode//电测量编码 100229
            vm.eleNum = item.pointNumber
          } else if (item.displayName == '水') {
            vm.waterNode = item.measuredId //水计量点 100401
            vm.waterCode = item.pointCode
            vm.waterNum = item.pointNumber
          }
        }
        vm.chartMaxMinData = findDataByParam(
          "chartMaxMinData",
          true,
          res.data
        );
        vm.StandardCoalCoefficientOfElectricity = findDataByParam(
          "StandardCoalCoefficientOfElectricity",
          false,
          res.data
        );
        vm.StandardCoalCoefficientOfWater = findDataByParam(
          "StandardCoalCoefficientOfWater",
          false,
          res.data
        );
        vm.data.data.yerDate.xdata = getxData();
        vm.data.data.ee_tempdata[0].name = getTime(0)[0].slice(0, 10) + " 用电量";
        vm.data.data.ee_tempdata[1].name = getTime(0)[2].slice(0, 10) + " 用电量";
        vm.data.data.ww_tempdata[0].name = getTime(0)[0].slice(0, 10) + " 用水量";
        vm.data.data.ww_tempdata[1].name = getTime(0)[2].slice(0, 10) + " 用水量";
        vm.getdata();
      }
    },
    async getTjParams (obj) {
      //获取看板柱状图年月日周柱状图接口
      let vm = this;
      let res = await Promise.all(obj)
      //将后台的时间数据格式转化成我们想要的
      let yearEle = "",
        monthEle = "",
        weekEle = "",
        dayEle = "";
      yearEle = vm.changeTime(vm.yearEle, res[0].data, 5); //返回的电
      yearEle = this.getFull(yearEle, "5");
      vm.combine(yearEle, 0); //年单耗柱状图数据
      monthEle = vm.changeTime(vm.monthEle, res[1].data, 4); //返回的电
      monthEle = this.getFull(monthEle, "3");
      vm.combine(monthEle, 1); //月单耗柱状图数据
      weekEle = vm.changeTime(vm.weekEle, res[2].data[0], 3); //返回的电
      weekEle = this.getFull(weekEle, "2");
      vm.combine(weekEle, 2); //周单耗柱状图数据
      dayEle = vm.changeTime(vm.dayEle, res[3].data[0], 2); //返回的电
      dayEle = this.getFull(dayEle, "1");  //补空
      vm.combine(dayEle, 3); //日单耗柱状图数据
      let eleArr = []; //今日用电量
      let waterArr = []; //今日用水量
      let leleArr = []; //昨日用电量
      let lwaterArr = []; //昨日用水量
      eleArr = vm.changeTime(vm.todayHourElc, res[4].data, 1); //返回的符合时间格式的数据电
      eleArr = vm.getFsNh(eleArr); //用电把空值补齐
      waterArr = vm.changeTime(vm.todayHourWat, res[5].data, 1); //返回的水
      waterArr = vm.getFsNh(waterArr); //用水把空值补齐
      leleArr = vm.changeTime(vm.lastHourElc, res[6].data, 1); //返回的 昨日电
      leleArr = vm.getFsNh(leleArr); //用电把空值补齐
      lwaterArr = vm.changeTime(vm.todayHourWat, res[7].data, 1); //返回的昨日水
      lwaterArr = vm.getFsNh(lwaterArr); //用水把空值补齐
      this.data.data.ee_tempdata[0].data = eleArr;
      this.data.data.ee_tempdata[1].data = leleArr;
      this.data.data.ww_tempdata[0].data = waterArr;
      this.data.data.ww_tempdata[1].data = lwaterArr;
    },
    /* 获取左上角统计量跟罗盘数据 */
    async getTj (obj) {
      let vm = this;
      let res = await Promise.all(obj)
      /* 今日电水 */
      vm.tyd = !res[0].data && res[0].data != 0 ? '' : parseFloat(res[0].data).toFixed(2);
      vm.tys = !res[1].data && res[1].data != 0 ? '' : (parseFloat(res[1].data) * 1000).toFixed(2);
      let tys = !res[1].data && res[1].data != 0 ? '' : (parseFloat(res[1].data)).toFixed(2);
      /* 今时电水 */
      let hourEle = !res[2].data && res[2].data != 0 ? '' : parseFloat(res[2].data).toFixed(2);
      let hourWater = !res[3].data && res[3].data != 0 ? '' : parseFloat(res[3].data).toFixed(2);
      let carddata = [];
      carddata.push({
        name: '总用电量',
        unit: '(kW▪h)',
        icon: 'yearPower_',
        value: vm.tyd
      });
      carddata.push({
        name: '总用水量',
        unit: '(m³)',
        icon: 'yearWater_',
        value: tys
      });
      vm.carddata = carddata;
      let d = hourEle == 0.0 ? 0 : hourEle; //电
      d = parseFloat(d).toFixed(2);;
      let s = hourWater == 0.0 ? 0 : hourWater; //水
      s = parseFloat(s).toFixed(2);;
      let yda =
        hourEle == 0
          ? 0
          : (hourEle) *
          parseFloat(vm.StandardCoalCoefficientOfElectricity);
      let ysa =
        hourWater == 0
          ? 0
          : (hourWater) *
          parseFloat(vm.StandardCoalCoefficientOfWater);
      let ab = parseFloat((parseFloat(hourEle) + parseFloat(hourWater))).toFixed(4);
      d = hourEle == '' ? '-' : hourEle;
      s = hourWater == '' ? '-' : hourWater;
      vm.threedata.push(d); //电罗盘数据
      vm.threedata.push(s); //水罗盘数据
    },
    /* isWater  是否为水 */
    getFsNh (data, isWater) {
      let typeData = [];
      for (var i = 0; i < 24; i++) {
        //将没有的数值全部补满
        let index = i;
        if (i < 10) {
          index = "0" + i;
        }
        typeData.push({
          value: "-",
          time: index + "时"
        });
      }
      for (var j = 0; j < typeData.length; j++) {
        let item = data.find(obj => {
          return obj.time == typeData[j].time;
        });
        if (item) {
          if (isWater) {
            if (item.value != 0 && item.value != '-') {
              typeData[j].value = parseFloat(item.value) * 1000;
            }
          } else {
            typeData[j].value = item.value;
          }
        }
      }
      return typeData;
    },
    //将空值补空  data补空的数据   type补空的时间类型
    getFull (data, type) {
      let nowTime = new Date();
      let typeData = [];
      if (type == "5") {
        //年
        typeData.push({
          value: "-",
          time: utils.formatDate(
            nowTime.setFullYear(nowTime.getFullYear() - 1),
            "yyyy"
          )
        });
        typeData.push({
          value: "-",
          time: utils.formatDate(new Date(), "yyyy")
        });
      } else if (type == "3") {
        //月
        let newTime =
          formatDate(new Date().setMonth(new Date().getMonth()), "yyyy-MM-") +
          "01";
        typeData.push({
          value: "-",
          time:
            utils.formatDate(
              new Date(newTime).setMonth(new Date(newTime).getMonth() - 4),
              "yyyy-MM"
            ) + "/01"
        });
        newTime =
          formatDate(new Date().setMonth(new Date().getMonth()), "yyyy-MM-") +
          "01";
        typeData.push({
          value: "-",
          time:
            utils.formatDate(
              new Date(newTime).setMonth(new Date(newTime).getMonth() - 3),
              "yyyy-MM"
            ) + "/01"
        });
        newTime =
          formatDate(new Date().setMonth(new Date().getMonth()), "yyyy-MM-") +
          "01";
        typeData.push({
          value: "-",
          time:
            utils.formatDate(
              new Date(newTime).setMonth(new Date(newTime).getMonth() - 2),
              "yyyy-MM"
            ) + "/01"
        });
        newTime =
          formatDate(new Date().setMonth(new Date().getMonth()), "yyyy-MM-") +
          "01";
        typeData.push({
          value: "-",
          time:
            utils.formatDate(
              new Date(newTime).setMonth(new Date(newTime).getMonth() - 1),
              "yyyy-MM"
            ) + "/01"
        });
        newTime =
          formatDate(new Date().setMonth(new Date().getMonth()), "yyyy-MM-") +
          "01";
        typeData.push({
          value: "-",
          time:
            utils.formatDate(
              new Date(newTime).setMonth(new Date(newTime).getMonth()),
              "yyyy-MM"
            ) + "/01"
        });
      } else if (type == "2") {
        //周
        let ww = getxData();
        for (let j = 0; j < 5; j++) {
          typeData.push({
            time: "",
            value: "-"
          });
          typeData[j].time = ww[7 + j];
          typeData[j].value = "-";
        }
      } else if (type == "1") {
        //天
        typeData.push({
          value: "-",
          time: utils.formatDate(
            nowTime.setDate(nowTime.getDate() - 6),
            "MM.dd"
          )
        });
        for (let i = 0; i < 6; i++) {
          typeData.push({
            value: "-",
            time: utils.formatDate(
              nowTime.setDate(nowTime.getDate() + 1),
              "MM.dd"
            )
          });
        }
      }
      for (var j = 0; j < typeData.length; j++) {
        let item = data.find(obj => {
          return obj.time == typeData[j].time;
        });
        if (item) {
          typeData[j].value = item.value;
        }
      }
      return typeData;
    },
    combine (newEle, index) {
      //将时间相同的电和产量的数据合并为一个量
      let vm = this;
      let ele = JSON.parse(JSON.stringify(newEle));
      vm.data.data.yerDate.ydata[index] = []
      for (let i in ele) {
        if (ele[i].value == "-") {
          ele[i].value = "-";
        } else {
          ele[i].value = ele[i].value == 0 ? 0 : (ele[i].value).toFixed(2);
        }
        vm.data.data.yerDate.ydata[index].push(ele[i]);
      }
      return vm.data.data.yerDate.ydata[index];
    },
    ycombine (data, newEle, newCtr, index) {
      //求用电量，用水，产量
      let vm = this;
      let ele = JSON.parse(JSON.stringify(newEle));
      data[index].data = []
      for (let i in ele) {
        let item = i
        // ctr.find(obj => {
        //   return obj.time == ele[i].time;
        // });
        if (item) {
          if (ele[i].value === "-" || item.value === "-") {
            ele[i].value = "-";
            data[index].data.push(ele[i]);
          } else {
            ele[i].value =
              parseFloat(item.value) == 0 || parseFloat(newEle[i].value) == 0
                ? 0
                : (parseFloat(ele[i].value) / parseFloat(item.value)).toFixed(
                  2
                );
            data[index].data.push(ele[i]);
          }
        }
      }
      return data[index].data;
    },
    changeTime (data, res, index) {
      //将后台的时间数据格式转化成我们想要的
      data = JSON.parse(JSON.stringify(data));
      if (res.length > 0) {
        data = getX(res, index);
      } else {
        data = [];
      }
      return data;
    },
    //将相同周的数据相加   weekData//接口数据
    addWeek (weekData) {
      let data = JSON.parse(JSON.stringify(weekData));
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        for (let j = i; j < data.length; j++) {
          if (data[i].time == data[j].time) {
            data[i].value += data[j].value;
          }
        }

        if (arr.findIndex(obj => obj.time == data[i].time) == -1) {
          arr.push(data[i]);
        }
      }
      return data;
    },
    async getdata () {
      let vm = this;
      //上左边统计数据开始
      nowtime = new Date();
      nowtime.setDate(nowtime.getDate());
      startTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      nowtime.setDate(nowtime.getDate() + 1);
      endTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      let hourTime = new Date();
      hourTime.setHours(nowtime.getHours());
      let hourStart = utils.formatDate(hourTime, "yyyy-MM-dd hh") + ":00:00";
      hourTime.setHours(hourTime.getHours() + 1);
      let hourEnd = utils.formatDate(hourTime, "yyyy-MM-dd hh") + ":00:00";
      /* 今日电水 今时点水 */
      let params = [
        {
          measureId: vm.eleNode,
          startTime: startTime,
          endTime: endTime,
          pointCode: vm.eleCode,
          pointNumber: vm.eleNum
        },
        {
          measureId: vm.waterNode,
          startTime: startTime,
          endTime: endTime,
          pointCode: vm.waterCode,
          pointNumber: vm.waterNum
        },
        {
          measureId: vm.eleNode,
          startTime: hourStart,
          endTime: hourEnd,
          pointCode: vm.eleCode,
          pointNumber: vm.eleNum
        },
        {
          measureId: vm.waterNode,
          startTime: hourStart,
          endTime: hourEnd,
          pointCode: vm.waterCode,
          pointNumber: vm.waterNum
        },
      ]
      let paramsData = [];
      for (let i = 0; i < params.length; i++) {
        let item = params[i];
        paramsData.push(
          vm.$api.quantity.getQuantity(
            item.measureId,
            item.startTime,
            item.endTime,
            item.pointCode,
            item.pointNumber
          )
        )
      }
      await vm.getTj(paramsData);
      //上左边统计数据结束
      //上右边单耗柱状图接口开始
      //年单耗柱状图开始
      let nowtime = new Date();
      nowtime.setFullYear(nowtime.getFullYear() - 1);
      let startTime = utils.formatDate(nowtime, "yyyy") + "/01/01 00:00:00";
      nowtime.setFullYear(nowtime.getFullYear() + 2);
      let endTime = utils.formatDate(nowtime, "yyyy") + "/01/01 00:00:00";
      //电量
      let arrData = [];
      arrData.push(vm.$api.quantity.getQuantityYear(
        vm.eleNode,
        startTime,
        endTime,
        vm.eleCode,
        vm.eleNum
      ))
      //年单耗柱状图结束
      //月单耗柱状图开始
      nowtime = new Date();
      nowtime.setMonth(nowtime.getMonth() + 1);
      endTime = utils.formatDate(nowtime, "yyyy-MM") + "/01 00:00:00";
      nowtime.setMonth(nowtime.getMonth() - 5);
      startTime = utils.formatDate(nowtime, "yyyy-MM") + "/01 00:00:00";
      //电量
      arrData.push(vm.$api.quantity.getQuantityMonth(
        vm.eleNode,
        startTime,
        endTime,
        vm.eleCode,
        vm.eleNum
      ))
      //月单耗柱状图结束
      //周单耗柱状图开始 ;
      let dTime = new Date();
      let endWeek = new Date();
      let startWeek = new Date();
      endWeek.setDate(
        endWeek.getDate() + (7 - (endWeek.getDay() == 0 ? 7 : endWeek.getDay()))
      );
      let nowTime = formatDate(endWeek, "yyyy-MM-dd hh:mm:ss"); //拿取当前时间
      var timestamp = Date.parse(nowTime) / 1000;
      let ee = timestamp - 86400 * 34;
      let newE = timestamp + 86400;
      startTime = formatTime(ee, "Y-M-D ") + "00:00:00"; //时段的环期开始时间
      endTime = formatTime(newE, "Y-M-D ") + "00:00:00"; //时段的环期结束时间
      //电量
      arrData.push(vm.$api.quantity.getQuantityDay(
        vm.eleNode,
        startTime,
        endTime,
        vm.segments,
        vm.eleCode,
        vm.eleNum
      ))
      //周单耗柱状图结束
      //日单耗柱状图开始
      nowtime = new Date();
      nowtime.setDate(nowtime.getDate() + 1);
      endTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      nowtime.setDate(nowtime.getDate() - 7);
      startTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      //电量
      arrData.push(vm.$api.quantity.getQuantityDay(
        vm.eleNode,
        startTime,
        endTime,
        vm.segments,
        vm.eleCode,
        vm.eleNum
      ))
      //上右边单耗柱状图接口结束
      //下左单片用电分时能耗开始
      nowtime = new Date();
      nowtime.setDate(nowtime.getDate());
      startTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      nowtime.setDate(nowtime.getDate() + 1);
      endTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      arrData.push(vm.$api.quantity.getQuantityHour(
        vm.eleNode,
        startTime,
        endTime,
        vm.eleCode,
        vm.eleNum
      ))
      //水量
      arrData.push(vm.$api.quantity.getQuantityHour(
        vm.waterNode,
        startTime,
        endTime,
        vm.waterCode,
        vm.waterNum
      ))
      nowtime = new Date();
      nowtime.setDate(nowtime.getDate());
      endTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      nowtime.setDate(nowtime.getDate() - 1); //昨日
      startTime = utils.formatDate(nowtime, "yyyy-MM-dd") + " 00:00:00";
      arrData.push(vm.$api.quantity.getQuantityHour(
        vm.eleNode,
        startTime,
        endTime,
        vm.eleCode,
        vm.eleNum
      ))
      //水量
      arrData.push(vm.$api.quantity.getQuantityHour(
        vm.waterNode,
        startTime,
        endTime,
        vm.waterCode,
        vm.waterNum
      ))
      /* 
      年电，电产量
       */
      await vm.getTjParams(arrData);
      vm.timer && clearInterval(vm.timer);
      vm.timer = setInterval(async () => {
        await vm.getTjParams(arrData);
      }, 2 * 60 * 1000);
      vm.$nextTick(() => {
        vm.barDate = vm.data.data.yerDate;
        vm.yd = vm.data.data.ee_tempdata;
        vm.ys = vm.data.data.ww_tempdata;
      })
      var sp = document.getElementsByClassName("insight_ws_field_middle");
      sp.fieldname;
    }
  }
};
</script>
<style lang="scss" scoped>
// /* 顶部 */
.top {
  overflow: hidden;
}
.titleChina_ {
  font-size: 2.4rem;
  font-family: FZLTZHK;
  color: #fff;
  text-align: center;
  margin-top: 7px;
}
.titleEnglish_ {
  font-size: 1rem;
  font-family: FZLTHJW;
  color: #fff;
  text-align: center;
}
.logo i {
  background: url(../../assets/image/nykb/cpdhtj_jlt.png) no-repeat -4px -6px;
  display: inline-block;
  width: 120px;
  height: 109px;
}
.weather {
  overflow: hidden;
  width: 30%;
  margin: 2.75rem 0 0 21rem;
}
.title {
  width: 40%;
  text-align: center;
  margin-top: 5px;
}
.titleBg {
  width: 100%;
  height: 90px;
  background: url(../../assets/image/nykb/titleBg.png) no-repeat center center;
  background-size: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
.logo {
  width: 30%;
  text-align: right;
  float: right;
  margin-top: -0.75rem;
  margin-right: 1rem;
}
.topBg {
  background: #ccd7e8;
  color: #00368c;
  font-size: 0.7rem;
  font-family: FZLTZHK;
  padding: 2px 10px;
  display: inline-block;
}
.topBgInfo {
  margin-top: 12px;
  font-family: FZLTHJW;
  font-size: 0.9;
  color: #666;
}
/* 顶部 */
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
}
.boxbgcolor {
  background: #fff;
}
.el-row:nth-child(1) {
  width: 100%;
  height: 20%;
  margin: 0 !important;
  padding-bottom: 0.5rem;
}
.el-row:nth-child(2) {
  width: 100%;
  height: 40%;
  margin: 0 !important;
  padding-bottom: 0.5rem;
}
.el-row:nth-child(3) {
  width: 100%;
  height: 40%;
  margin: 0 !important;
  padding-bottom: 0.5rem;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
</style>
